export const commandType = "SCHEDULE_SET_PAYLOAD_RECORDING";
export const label = "Set payload recording";
export const isAdminOnly = true;
export const isAdvanced = false;
export const organizations = [];
